/**
 * TEXTE DER TEILAUFGABEN, EIGENTÜMER UND DES BOARD-FOKUS (Spec Teilaufgaben R20–R28) — EINE Stelle für alle neuen
 * Anwendertexte des Web (Global Constraints), Schlüssel englisch. Kein neuer i18n-Mechanismus (Spec „Bedenken").
 * Die Fehlertexte der Wege liefert der Server (Domäne), der Hinweis „zurückgenommen" kommt aus der 410.
 */
const anzahl = (n: number, eins: string, viele: string) => (n === 1 ? `1 ${eins}` : `${n} ${viele}`);

export const HIERARCHY_TEXT = {
  section: "Teilaufgaben",
  /** Der Reiter „Verknüpfungen“ des Ticketdialogs (Bereich Tickets, Kalender, Objektpanel) — `verknuepfungenReiter`. */
  linksTab: "Verknüpfungen",
  /** Der Pfad über dem Steckbrief, wenn das Ticket als Objektpanel über einem anderen Ort liegt („Öffnen statt Springen“). */
  panelPath: "Tickets",
  showInBoard: "Im Board zeigen",
  endFocus: "Fokus beenden",
  empty: "Noch keine Teilaufgaben. Eine Teilaufgabe ist ein eigenes Ticket; wer sie bekommt, ist Eigentümer und zuständig.",
  attachExisting: "Vorhandenes Ticket zuordnen …",
  attachTitle: "Vorhandenes Ticket zuordnen",
  attachSearch: "Nummer oder Titel",
  attachNone: "Kein passendes Ticket.",
  quickTitle: "Neue Teilaufgabe",
  quickPerson: "Person",
  quickPersonNone: "ohne Person (Eigentümer ich)",
  dueDate: "Fällig bis",
  /** Eigener Name des Feldes der Schnellanlage (enthält die sichtbare Beschriftung „Fällig bis“, WCAG 2.5.3). */
  quickDueDate: "Fällig bis der neuen Teilaufgabe",
  create: "Anlegen",
  systemHint: "Mit der ersten Teilaufgabe wirst Du Eigentümer dieses Tickets.",
  partOf: "Teil von",
  detach: "Lösen",
  takeOver: "Übernehmen",
  owner: "Eigentümer",
  system: "System",
  systemNote: "kein Eigentümer",
  overdue: "überschritten",
  teamLikeParent: "wie Elternticket",
  person: "Person",
  status: "Status",
  stateOpen: "offen",
  stateDone: "erledigt",
  stateArchived: "Archiviert",
  columnNumber: "Nr.",
  columnTitle: "Titel",
  failCreate: "Die Teilaufgabe ließ sich nicht anlegen.",
  failChange: "Die Teilaufgabe ließ sich nicht ändern.",
  failAttach: "Das Ticket ließ sich nicht zuordnen.",
  failUndo: "Rückgängig ist nicht gelungen.",
  failReload: "Gespeichert – die Teilaufgaben ließen sich aber nicht neu laden. Bitte das Ticket neu öffnen.",
  railName: (nummer: string) => `Teilaufgaben von ${nummer}`,
  resubmit: "Wiedervorlage",
  none: "–",
  watch: "Beobachten",
  unwatch: "Nicht mehr beobachten",
  // Eine ANDERE Person austragen fragt (Entscheid 688); sich selbst austragen nicht — das ist „Nicht mehr beobachten“.
  removeWatcherTitle: (name: string): string => `${name} als Beobachter austragen?`,
  removeWatcherText: (name: string): string =>
    `${name} wird als Beobachter aus diesem Ticket ausgetragen; eintragen lässt sich die Person jederzeit wieder.`,
  removeWatcher: "Austragen",
  muted: "Du bekommst zu diesem Ticket keine Meldungen.",
  noRoles: "Du bekommst zu diesem Ticket keine Meldungen, solange Du es nicht beobachtest.",
  filterQueue: "Warteschlange meiner Teams",
  filterDelegated: "Von mir delegiert",
  due: (tag: string) => `fällig ${tag}`,
  progress: (done: number, total: number) => `${done}/${total}`,
  progressSpoken: (done: number, total: number) => `${done} von ${anzahl(total, "Teilaufgabe", "Teilaufgaben")} erledigt`,
  childOf: (parent: string) => `Teilaufgabe von ${parent}`,
  realNumber: (real: string) => `Ticket ${real}`,
  realNumberUnder: (real: string, pos: number, parent: string) => `Ticket ${real} · Position ${pos} unter ${parent}`,
  levelOf: (level: number, parent: string, title: string | null) =>
    `Ebene ${level} · Teil von ${parent}${title === null ? "" : ` ${title}`}`,
  ownerOf: (name: string) => `Eigentümer ${name}`,
  assigneeOf: (name: string) => `Zuständig ${name}`,
  unassigned: "nicht zugewiesen",
  queueOf: (team: string) => `Warteschlange Team ${team}`,
  outsideFilter: (n: number) => `+${n} außerhalb des Filters`,
  focusCounter: (n: number) => `Fokus ${n}`,
  focusExtra: (n: number) => `+${n}`,
  focusColumnCount: (count: number, inFocus: number) => `${count} (${inFocus})`,
  rolesIntro: "Du bekommst Meldungen als ",
  roleNames: { OWNER: "Eigentümer", ASSIGNEE: "Zuständig", WATCHER: "Beobachter", PARENT_OWNER: "Eigentümer des Elterntickets" },
  receiptCreated: (nummer: string, person: string | null, uebernommen: string | null) =>
    `Teilaufgabe ${nummer} angelegt${person === null ? "" : ` und an ${person} delegiert`} – sofort gespeichert`
    + (uebernommen === null ? "" : `. Du bist jetzt Eigentümer von ${uebernommen}`),
  receiptDone: (nummer: string) => `${nummer} erledigt`,
  receiptReopened: (nummer: string) => `${nummer} wieder offen`,
  receiptAttached: (kind: string, eltern: string) => `${kind} ist jetzt Teilaufgabe von ${eltern}`,
  receiptDetached: (kind: string) => `${kind} ist jetzt eine eigenständige Aufgabe`,
  undoDone: "Rückgängig gemacht",
  confirmDone: { title: "Teilaufgabe erledigen?", button: "Erledigen" },
  confirmReopen: { title: "Teilaufgabe wieder öffnen?", button: "Wieder öffnen" },
  confirmDoneText: (titel: string, person: string | null, offen: number) =>
    `„${titel}“${person === null ? "" : ` (${person})`}`
    + (offen === 0 ? "." : ` – ${anzahl(offen, "offene Teilaufgabe bleibt", "offene Teilaufgaben bleiben")} offen.`),
  openChildrenTitle: (n: number) => `${anzahl(n, "Teilaufgabe", "Teilaufgaben")} offen – trotzdem erledigen?`,
  openChildrenText: (zeilen: readonly { title: string; status: string; person: string | null }[]) =>
    zeilen.map((z) => `${z.title} (${z.status}${z.person === null ? "" : `, ${z.person}`})`).join("; "),
  openChildrenConfirm: "Trotzdem erledigen",
  openChildrenCancel: "Weiter bearbeiten",
  attachConfirmTitle: (kind: string, eltern: string) => `${kind} als Teilaufgabe von ${eltern} zuordnen?`,
  attachConfirmText: (bisher: string | null) => (bisher === null ? "" : `Bisher Teil von ${bisher}.`),
  attachConfirm: "Zuordnen",
  detachConfirmTitle: (kind: string, eltern: string) => `${kind} aus ${eltern} lösen?`,
  detachConfirmText: "Sie wird eine eigenständige Aufgabe.",
  teamSubtreeTitle: (n: number) => `Team für dieses Ticket und ${anzahl(n, "Teilaufgabe", "Teilaufgaben")} ändern?`,
  teamSubtreeConfirm: "Team ändern",
  /** Verlauf (R4, E444): dieselben Wörter wie `notificationRules.ts` der Domäne, die `web` nicht importiert. */
  history: {
    owner: (von: string, nach: string) => `Eigentümer: ${von} → ${nach}`,
    parentSet: (nummer: string) => `Teil von ${nummer}`,
    parentCleared: (nummer: string) => `gelöst aus ${nummer}`,
    parentMoved: (von: string, nach: string) => `umgehängt: ${von} → ${nach}`,
    dueDate: (von: string, nach: string) => `Fällig bis: ${von} → ${nach}`,
    subtask: (nummer: string, titel: string, art: string) => `Teilaufgabe ${nummer} „${titel}“${art === "" ? "" : ` ${art}`}`,
    added: { CREATED: "angelegt", MOVED: "zugeordnet" } as Record<string, string>,
    removed: { WITHDRAWN: "zurückgenommen", MOVED: "umgehängt" } as Record<string, string>,
    closedWithParent: "beim Umzug mit dem erledigten Elternticket geschlossen",
    removedOwner: (name: string) => `Eigentümer ${name}`,
    source: (anzeige: string, titel: string) => `${anzeige} ${titel}`,
  },
} as const;
